import React, { useEffect, useState } from "react"
import { useSelector } from "react-redux";
import classes from './ReflectionAnswers.module.css'
import ReflectionView from "../../Reflection/ReflectionActions/ReflectionView/ReflectionView";
import { throwApiError } from "../../store/error-handling-actions";
import { assessmentsApi } from "../../../../utils";
import { ActivityTypeEnumText } from "../../models/ActivityTypeEnum";
import BackdropPopup from "../../UI/Popups/BackdropPopup/BackdropPopup";

const ReflectionAnswers = ({ setShowReflection, lessonId, studyGroupId }) => {

    const texts = useSelector(state => state.translate.texts);
    const robotImg = useSelector(state => state.application.robotImg);
    const [index, setIndex] = useState(0);
    const [questions, setQuestions] = useState([])
    const [currentQuestions, setCurrentQuestions] = useState([]);


    useEffect(() => {
        assessmentsApi.assessmentsFilterRangePost({
            assessmentFilterRange: {
                toCId: lessonId,
                activityType: ActivityTypeEnumText.Reflection,
                studyGroupId: studyGroupId,
                unsubmitted: true
            }
        }, (error, resdata, response) => {
            if (error) {
                throwApiError({ userMessage: texts.genralErrorMessage, error: error, statusCode: response?.statusCode, message: "genralErrorMessage " + error.message, level: 2, component: "ReflectionQuestions", line: 16 })
            } else {
                if (resdata.assessments?.length !== 0) {
                    const temp = []
                    resdata.assessments.forEach(element => {
                        const contentData = JSON.parse(element.contentData)
                        temp.push({ text: contentData.text, type: contentData.type, id: element.id, sortIndex: element.sortIndex })
                    });
                    setQuestions(temp)
                    setCurrentQuestions(temp.slice(index, index + 2))

                }
                else {
                    setShowReflection(false)
                }
            }
        })
    }, [])


    useEffect(() => {
        setCurrentQuestions(questions.slice(index, index + 2))
    }, [index])

    function confirmPopup(e) {
        e.stopPropagation()
        setShowReflection(false)
    }

    const updateAnswer = (question) => {
        const newList = [...questions];
        newList[index] = question;
        setQuestions(newList)
    }

    return (
        <>
            {questions.length > 0 &&
                <BackdropPopup myHeight='auto' >
                    <div className={classes.ReflectionPopupContainer}>
                        {currentQuestions.length > 0 ?
                            currentQuestions.map((question, index) => {
                                return <div className={index === 0 && currentQuestions.length > 1 ? classes.UnderLine : classes.Question}>
                                    <ReflectionView
                                        key={question.id}
                                        question={question}
                                        isStudent={true}
                                        index={index}
                                        hundleUpdateAnswer={updateAnswer}
                                        studyGroupId={studyGroupId} />
                                </div>
                            }) :
                            <div>
                                <img className={classes.RobotImg} src={robotImg} />
                                <div className={classes.TnxText}>{texts.tnxReflection}</div>
                            </div>
                        }
                        <button className={classes.NextBtn}
                            onClick={(e) => index < questions.length ? setIndex(index + 2) : confirmPopup(e)}>
                            {currentQuestions.length > 0 ? texts.theNext : texts.end}
                        </button>
                    </div>
                </BackdropPopup>}
        </>
    )
}

export default ReflectionAnswers;